export const TimelyPlanName = {
  BASE: 'base',
  BUILD: 'build',
  ELEVATE: 'elevate',
  INNOVATE: 'innovate',
};
